import { useState, useCallback } from "react";
import { KeyStorageAPI, KeyStorageData, Account, Helpers, AccountErrorMessages } from "src/common";

export function useCreateNewPassword(current_account: Account, auth_token: string) {
    const [loading, setLoading] = useState<boolean>(false);
    const [new_auth_token, setNewAuthToken] = useState<string | undefined>();
    const [error_message, setError] = useState<string | undefined>();
    const [stack, setStack] = useState<any>();
    // auth_token = KeyStorageData.authenticationToken(user_id, current_password);
    /* Description: Calls the rekey keystorage call to change the password.
        NOTE: we do not allow the user to enter one of their previous passwords. (KSS will send us an error in this case) */
    const createNewPassword = useCallback(async (new_password: string) => {
        if (!!current_account && !!auth_token) {
            setLoading(true);
            try {
                const token = await KeyStorageData.authenticationToken(current_account.user_id, new_password);
                const _new_auth_token = Helpers.b64Encode(token);
                const account_ids = Account.getAccountIdentifiers(current_account);
                const wrapped_data = await KeyStorageData.wrapKSSData(
                    new_password,
                    account_ids.user_key,
                    account_ids.device_key,
                    1,
                    current_account.current_device_id
                );

                const response = await KeyStorageAPI.rekeyUser(
                    account_ids,
                    auth_token,
                    wrapped_data,
                    undefined,
                    Helpers.b64Encode(current_account.user_key.public_user_key.verify_key.public_key),
                    _new_auth_token
                );

                setLoading(false);
                if (!response.isError) {
                    // Success - update the auth token in the store
                    setNewAuthToken(_new_auth_token);
                } else {
                    const message = (!!response.data.error && (typeof response.data.error === "string")) ? response.data.error : AccountErrorMessages.error_changing_password;
                    setError(message);
                    setStack(response.data);
                }
            } catch (_error: unknown) {
                setLoading(false);
                setError(AccountErrorMessages.error_changing_password);
                setStack(_error);
            }
        } else {
            setLoading(false);
            setError(AccountErrorMessages.error_changing_password);
        }
    }, []);

    // Description: Reset hook
    const reset = useCallback(() => {
        setLoading(false);
        setNewAuthToken(undefined);
        setError(undefined);
        setStack(undefined);
    }, []);

    return {
        createNewPassword,
        reset,
        loading,
        new_auth_token,
        error_message,
        stack
    };
}